<div class="hiring-manager-open-positions-container">
  <div class="navigation-breadcrumb">
    <span class="breadcrumb-text" (click)="navigateToVendorManagement()">
      {{ routesEnum.OpenPositionsBreadcrumb }}
    </span>
  </div>
  <div class="custome-tab">
    <div class="navigation-tabs-container">
      <emerald-tab-bar
        [tabsData]="tabsData"
        class="custom-green"
        [showContent]="true"
        (selectedTabChange)="onTabChange($event)"
      >
      </emerald-tab-bar>
      <emerald-button
        *ngIf="selectedTab?.label === tabLabel.OpenPositions"
        [type]="'Primary'"
        label="Raise Hiring Request"
        size="Medium"
        (onClick)="raiseHirinRequest()"
      ></emerald-button>
    </div>
    <div
      class="op-card hm-card"
      *ngIf="selectedTab?.label === tabLabel.OpenPositions"
    >
      <!-- Toolbar: search left, filter right -->
      <div class="op-toolbar">
        <div class="search-child">
          <emerald-input
            (keyup)="searchItem($event)"
            [label]="'Search'"
            [trailingIcon]="'search'"
            [value]="filterText"
            ><emerald-icon
              *ngIf="filterText?.length && filterText.length > 0"
              [icon]="'close'"
              (click)="clearInput()"
            ></emerald-icon>
          </emerald-input>
        </div>
        <div class="op-chips" *ngIf="activeFilterCount">
          <span class="op-chip" *ngIf="opActiveFilters.statuses.length">Status: <b>{{ opActiveFilters.statuses.join(', ') }}</b></span>
          <span class="op-chip" *ngIf="opActiveFilters.lobName">LOB: <b>{{ opActiveFilters.lobName }}</b></span>
          <span class="op-chip" *ngIf="opActiveFilters.projectName">Project: <b>{{ opActiveFilters.projectName }}</b></span>
          <span class="op-chip" *ngIf="opActiveFilters.vendorName">Vendor: <b>{{ opActiveFilters.vendorName }}</b></span>
          <span class="op-chip" *ngIf="opActiveFilters.priority">Priority: <b>{{ opActiveFilters.priority }}</b></span>
        </div>
        <div class="op-spacer"></div>
        <div class="op-filter-slot">
          <button class="op-filterbtn" (click)="toggleFilterPanel()">
            <emerald-icon>filter_list</emerald-icon> Filters
            <span class="op-filter-count" *ngIf="activeFilterCount">{{ activeFilterCount }}</span>
          </button>
          <div class="op-filter-backdrop" *ngIf="showFilterPanel" (click)="showFilterPanel = false"></div>
          <div class="op-filter-panel" *ngIf="showFilterPanel">
            <div class="op-fp-head">Filter positions</div>
            <div class="op-fp-row">
              <label class="op-fp-label">Status</label>
              <div class="op-fp-checks">
                <label class="op-fp-check" *ngFor="let v of facetStatus">
                  <input type="checkbox" [checked]="opFilterDraft.statuses.includes(v)" (change)="toggleDraftStatus(v)" />
                  {{ v }}
                </label>
              </div>
            </div>
            <div class="op-fp-row">
              <label class="op-fp-label">LOB</label>
              <select class="op-fp-field" [(ngModel)]="opFilterDraft.lobName">
                <option value="">All</option>
                <option *ngFor="let v of facetLob" [value]="v">{{ v }}</option>
              </select>
            </div>
            <div class="op-fp-row">
              <label class="op-fp-label">Project</label>
              <select class="op-fp-field" [(ngModel)]="opFilterDraft.projectName">
                <option value="">All</option>
                <option *ngFor="let v of facetProject" [value]="v">{{ v }}</option>
              </select>
            </div>
            <div class="op-fp-row">
              <label class="op-fp-label">Vendor</label>
              <select class="op-fp-field" [(ngModel)]="opFilterDraft.vendorName">
                <option value="">All</option>
                <option *ngFor="let v of facetVendor" [value]="v">{{ v }}</option>
              </select>
            </div>
            <div class="op-fp-row">
              <label class="op-fp-label">Priority</label>
              <select class="op-fp-field" [(ngModel)]="opFilterDraft.priority">
                <option value="">All</option>
                <option value="Critical">Critical</option>
                <option value="Standard">Standard</option>
              </select>
            </div>
            <div class="op-fp-actions">
              <button class="op-fp-reset" (click)="resetFilterPanel()">Reset</button>
              <button class="op-fp-apply" (click)="applyFilterPanel()">Apply</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Table -->
      <div class="op-table-wrap" *ngIf="displayData.length > 0; else noData">
        <table class="op-table">
          <colgroup>
            <col style="width:6%" /><col style="width:15%" /><col style="width:6%" />
            <col style="width:8%" /><col style="width:9%" /><col style="width:9%" />
            <col style="width:8%" /><col style="width:10%" /><col style="width:11%" />
            <col style="width:6%" /><col style="width:7%" /><col style="width:8%" />
          </colgroup>
          <thead>
            <tr>
              <th class="sortable" (click)="sortBy('hiringRequestId')" (mouseenter)="showTip($event, 'Position ID')" (mouseleave)="hideTip()">Pos ID <span class="op-sort" [ngClass]="sortIndicator('hiringRequestId')"></span></th>
              <th class="sortable" (click)="sortBy('jobTitle')" (mouseenter)="showTip($event, 'Job Title')" (mouseleave)="hideTip()">Job Title <span class="op-sort" [ngClass]="sortIndicator('jobTitle')"></span></th>
              <th class="c sortable" (click)="sortBy('numberOfPositions')" (mouseenter)="showTip($event, 'Positions')" (mouseleave)="hideTip()">Positions <span class="op-sort" [ngClass]="sortIndicator('numberOfPositions')"></span></th>
              <th class="sortable" (click)="sortBy('lobName')" (mouseenter)="showTip($event, 'LOB')" (mouseleave)="hideTip()">LOB <span class="op-sort" [ngClass]="sortIndicator('lobName')"></span></th>
              <th class="sortable" (click)="sortBy('projectName')" (mouseenter)="showTip($event, 'Project')" (mouseleave)="hideTip()">Project <span class="op-sort" [ngClass]="sortIndicator('projectName')"></span></th>
              <th class="sortable" (click)="sortBy('skillName')" (mouseenter)="showTip($event, 'Primary Skill')" (mouseleave)="hideTip()">Primary Skill <span class="op-sort" [ngClass]="sortIndicator('skillName')"></span></th>
              <th class="sortable" (click)="sortBy('desiredStartDate')" (mouseenter)="showTip($event, 'Desired Start Date')" (mouseleave)="hideTip()">Desired Start <span class="op-sort" [ngClass]="sortIndicator('desiredStartDate')"></span></th>
              <th class="sortable" (click)="sortBy('vendorName')" (mouseenter)="showTip($event, 'Shared with Vendor')" (mouseleave)="hideTip()">Vendor <span class="op-sort" [ngClass]="sortIndicator('vendorName')"></span></th>
              <th>Comments</th>
              <th class="c sortable" (click)="sortBy('noOfCandidates')" (mouseenter)="showTip($event, 'Candidates Received')" (mouseleave)="hideTip()">Candidates <span class="op-sort" [ngClass]="sortIndicator('noOfCandidates')"></span></th>
              <th class="sortable" (click)="sortBy('status')" (mouseenter)="showTip($event, 'Status')" (mouseleave)="hideTip()">Status <span class="op-sort" [ngClass]="sortIndicator('status')"></span></th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of pagedRows; trackBy: trackByIndex">
              <td class="mono muted">{{ row.hiringRequestId }}</td>
              <td>
                <span class="op-jt-wrap">
                  <emerald-icon
                    *ngIf="isRowPriority(row)"
                    class="op-jt-flag"
                    [icon]="priority.flag"
                    [color]="priority.red"
                    [type]="'outlined'"
                    title="High priority"
                  ></emerald-icon>
                  <a
                    class="op-jt op-tip-txt job-title {{ row.hiringRequestId }}"
                    (mouseenter)="showTip($event, row.jobTitle)"
                    (mouseleave)="hideTip()"
                    (click)="showJobDtls(row)"
                  >{{ row.jobTitle }}</a>
                </span>
              </td>
              <td class="c"><span class="op-posnum">{{ row.numberOfPositions }}</span></td>
              <td (mouseenter)="showTip($event, row.lobName)" (mouseleave)="hideTip()"><span class="op-tip-txt">{{ row.lobName }}</span></td>
              <td (mouseenter)="showTip($event, row.projectName)" (mouseleave)="hideTip()"><span class="op-tip-txt">{{ row.projectName }}</span></td>
              <td (mouseenter)="showTip($event, joinSkills(row.skillName))" (mouseleave)="hideTip()"><span class="op-tip-txt">{{ joinSkills(row.skillName) }}</span></td>
              <td class="mono muted">{{ row.desiredStartDate | date: dateFormat.Month }}</td>
              <td (mouseenter)="showTip($event, transformSharedByVendor(row.vendorName))" (mouseleave)="hideTip()"><span class="op-tip-txt">{{ transformSharedByVendor(row.vendorName) }}</span></td>
              <td (mouseenter)="showTip($event, row.additionalComments)" (mouseleave)="hideTip()"><span class="op-tip-txt">{{ row.additionalComments }}</span></td>
              <td class="c"><span class="op-cand">{{ row.noOfCandidates }}</span></td>
              <td>
                <span class="op-pill" [ngClass]="statusClass(row.status)">
                  <span class="dot"></span>{{ row.status }}
                </span>
              </td>
              <td class="op-cell-actions">
                <div class="op-actions">
                  <emerald-button
                    [type]="'Light'"
                    [label]="'Edit'"
                    [size]="'Small'"
                    [icon]="'edit'"
                    [iconFillType]="'outlined'"
                    [disabled]="row?.status === 'Closed'"
                    (onClick)="editRow(row)"
                  ></emerald-button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <ng-template #noData>
        <section class="op-empty" aria-label="Records section" *ngIf="isDataLoaded">
          <h2 class="op-empty-title">No Records Found</h2>
          <img [src]="imageSrc" alt="No records illustration" class="op-empty-img" />
        </section>
      </ng-template>

      <!-- Pagination footer -->
      <div class="op-tfoot" *ngIf="displayData.length > 0">
        <div class="op-info">
          Showing <b>{{ rangeStart }}–{{ rangeEnd }}</b> of <b>{{ totalRecords }}</b> open positions
        </div>
        <div class="op-pager">
          <button class="pg" (click)="prevPage()" [disabled]="currentPageValue === 1" aria-label="Previous page">‹</button>
          <button
            *ngFor="let p of pageWindow; trackBy: trackByIndex"
            class="pg"
            [class.on]="p === currentPageValue"
            [disabled]="p === -1"
            (click)="goToPage(p)"
          >{{ p === -1 ? '…' : p }}</button>
          <button class="pg" (click)="nextPage()" [disabled]="currentPageValue >= totalPages" aria-label="Next page">›</button>
        </div>
        <div class="op-psize">
          <span>Rows</span>
          <select [value]="pageSizeValue" (change)="onPageSizeChange($event)" aria-label="Rows per page">
            <option [value]="5">5</option>
            <option [value]="10">10</option>
            <option [value]="20">20</option>
          </select>
        </div>
      </div>
    </div>
    <div *ngIf="errorMessage" class="error-message">
      {{ errorMessage }}
    </div>
    <app-hiring-manager-candidates
      [selectedTab]="selectedTab"
      *ngIf="selectedTab?.label === tabLabel.Candidates"
      [hiringRequestId]="hiringRequestId"
      [employeeLevel]="employeeLevel"
      (candidatesDataChange)="handleCandidatesDataChange($event)"
    ></app-hiring-manager-candidates>
    <app-modal-wrapper *ngIf="showJobDetails" [showModal]="showJobDetails">
      <app-job-details
        [openPositionData]="selectedJob"
        (close)="onJobDetailsClosed()"
      ></app-job-details>
    </app-modal-wrapper>
    <app-open-positions-flag-legend
      *ngIf="selectedTab?.label === tabLabel.OpenPositions"
      [legendItems]="legendItems"
    ></app-open-positions-flag-legend>
  </div>

  <!-- Fixed hover tooltip (full text for truncated cells) -->
  <div class="op-hovertip" *ngIf="hoverTip.show" [style.left.px]="hoverTip.x" [style.top.px]="hoverTip.y">
    {{ hoverTip.text }}
  </div>
</div>